import { TooltipComponent } from '@components/core/tooltip.component';
import { cn } from '@lib/utils';
import { FunctionComponent, ReactNode } from 'react';
import { BlueLabel } from './blue-label.component';

type TextWithLabelProps = {
  badge?: ReactNode;
  className?: string;
  label: ReactNode;
  labelClassName?: string;
  subtitleBadge?: ReactNode;
  title: string | ReactNode;
  /**
   * When true, truncates the title with ellipsis and shows full text on hover.
   */
  truncate?: boolean;
};

export const TextWithLabel: FunctionComponent<TextWithLabelProps> = (props) => {
  const { badge, className, label, labelClassName, subtitleBadge, title, truncate = false } = props;

  const titleContent = <div className={cn('font-medium', truncate && 'truncate')}>{title}</div>;

  const renderTitle = (): ReactNode => {
    if (truncate && typeof title === 'string') {
      return (
        <TooltipComponent
          trigger={titleContent}
          side="top"
        >
          {title}
        </TooltipComponent>
      );
    }
    return titleContent;
  };

  return (
    <div className={cn('flex flex-col text-base text-gray-600', truncate && 'min-w-0', className)}>
      <div className={cn('flex flex-row items-center gap-2', truncate && 'min-w-0')}>
        {renderTitle()}
        {badge}
      </div>

      <div className="flex items-center gap-2">
        <BlueLabel
          text={label}
          className={labelClassName}
        />
        {subtitleBadge && <div className="flex flex-row items-center gap-2">{subtitleBadge}</div>}
      </div>
    </div>
  );
};
